module.exports = __webpack_public_path__ + "0580d71b372c3ad48d7004c20c4827fc.png";